/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Berechnetestunden1Inputs */

const de__field_berechnetestunden1 = /** @type {(inputs: _Field_Berechnetestunden1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`berechnete Einheiten`)
};

/**

* @param {_Field_Berechnetestunden1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_berechnetestunden1 = /** @type {((inputs?: _Field_Berechnetestunden1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Berechnetestunden1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_berechnetestunden1(inputs)
});
export { _field_berechnetestunden1 as "_field_berechneteStunden" }